import React, {Component} from 'react';
import { CSSTransition, TransitionGroup } from 'react-transition-group';
import CloseBtn from '../../components/CloseBtn';
import InnerWrap from './WrapProject';
import BackSound from '../../components/BackSound';
import * as routes from '../../const/routes';
import * as videos from '../../const/videos';
import { withUiContext } from '../../UiContext';
import MenuBtn from '../../components/MenuBtn';
import NavContent from '../../components/NavContent';
import { products } from '../../const/projects';
import MapSection from '../../components/MapSection';
import MapLocation from '../../components/MapSection/MapLocation';

class Project extends Component {
    state = {
        intro:     this.props.ui.intro,
        navContent: false,
        popup:      {
            type:   null,
            opened: false,
            data:   null,
        },

        thisProducts: products.find((product) => product.id === 19),
    }

    toggleNav = () => {
        this.setState((prevState) => ({navContent: !prevState.navContent}));
    }

    onEnded = () => {
        this.setState({intro: false})
    }

    popupCloseHandler = () => {
        this.props.ui.videoEl.play();
        this.setState({
            popup: {
                classSfx: null,
                opened:   false,
                data:     null,
            },
        })
    }

    popupOpenHandler = (data) => {
        this.props.ui.videoEl.pause();
        this.setState({
            popup: {
                classSfx: 'project',
                opened:   true,
                data,
            },
        })
    }

    render() {
        const { intro, navContent, popup, thisProducts } = this.state;

        return (
            <InnerWrap
                popup = { popup }
                popupCloseHandler = { this.popupCloseHandler }
                title = { !intro && thisProducts.name }
                video = { videos.podst330_prod2_detail }
                intro = {{
                    status:  this.state.intro,
                    video:   videos.podst330_prod2_zoom,
                    onEnded: this.onEnded,
                }}
            >
                <div className = 'hud__container-content'>
                    {!intro && (
                        <MenuBtn
                            className = { `animated ${!navContent ? 'fadeInLeft' : 'fadeOutLeft'}` }
                            onClick = { this.toggleNav }
                            onMouseEnter = { this.props.ui.playOverSound }
                        />
                    )}

                    <TransitionGroup className = 'menu-outer'>
                        {navContent && (
                            <CSSTransition
                                classNames = 'menu-transition'
                                timeout = { 300 }>
                                <NavContent onClose = { this.toggleNav }/>
                            </CSSTransition>
                        )}
                    </TransitionGroup>

                    { !intro && (
                        <MapSection>
                            <MapLocation
                                className = { 'hud-map__location-project' }
                                label = { thisProducts.name }
                                link = { '#' }
                                style = {{left: 586, top: -21}}
                                onClick = { (event) => {
                                    event.preventDefault();
                                    this.popupOpenHandler(thisProducts);
                                } }
                            />
                        </MapSection>
                    )}
                </div>

                <div className = 'hud__container-controls'>
                    {!intro && (
                        <BackSound navContent = { navContent } />
                    )}

                    <CloseBtn link = { routes.PODST_330 } />
                </div>
            </InnerWrap>
        );
    }
}

export default withUiContext(Project);
